import React from "react";
import QuerySection from "../components/QuerySection";


const Enquiry = () => {
  return (
    <section className="query-section">
  <QuerySection/>
    </section>
  );
};

export default Enquiry;